// export const API_URL_USER = "http://localhost:8080/api/v1/users";
// export const API_URL_ACC = "http://localhost:8080/api/v1/accounts";
// export const API_URL_TRANSACTION = "http://localhost:8080/api/v1/transactions";

export const API_URL_USER =
  "https://expenses-income-api-web-dev.onrender.com/api/v1/users";
export const API_URL_ACC =
  "https://expenses-income-api-web-dev.onrender.com/api/v1/accounts";
export const API_URL_TRANSACTION =
  "https://expenses-income-api-web-dev.onrender.com/api/v1/atransactions";
